import { render } from "./DownForMaintenance.vue?vue&type=template&id=b4e92890"
import script from "./DownForMaintenance.vue?vue&type=script&lang=js"
export * from "./DownForMaintenance.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__